module.exports = __webpack_public_path__ + "static/media/news-bg.6bb44763.jpg";